exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-adm-btn[data-v-230039da]{font-size:.9rem;paddind:8px 20px}", ""]);

// exports
